<template>
  <div id="manage">
    <div class="content">
        <div class="title">记账系统</div>
        <div class="top">
            <div class="fl_left">
                <div class="wzbarBox">
                    <div class="wzbar" v-for="(name,index) in items" @click="tab(index,name)" :class="{'wzbars':index==num}">
                        <div>{{name.name}}</div>
                        <span></span>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <div class="botBox">
            <div class="bottomBox">
                <div class="selVox">
                    <div class="fl_left">
                        <span>共</span><span style="font-size:18px;color:#c30d23;">{{total}}</span><span>家</span>
                    </div>
                    <div class="fl_left">
                        <Select v-model="searchModel.country_id" @on-change="getCompanyList(1)" class="bordiv" clearable placeholder="请选择国家" filterable style="width:150px;margin:20px 0 20px 15px;">
                            <Option v-for="item in countryList" :key="item.id" :value="item.id" >{{ item.country}}</Option>
                        </Select>
                        <Select v-if="searchModel.country_id=='754a7162vx84bd6v92c1'||searchModel.country_id=='ac925162vx84bd6v898e'" clearable v-model="searchModel.province_id" placeholder="请选择省份" class="borDiv" style="width:150px;border:1px solid #e7e7eb;margin:20px 15px;" @on-change="getCompanyList(1)">
                            <Option v-for="item in provinceArr" :value="item.id" :key="item.id">{{ item.province }}</Option>
                        </Select>
                        <input type="password"  autocomplete="new-password" style="display: none;">
                        <Input 
                        id="demo" 
                        v-model="searchModel.keyword" 
                        icon="ios-search" 
                        placeholder="承办单位名称搜索" 
                        style="width: 200px;height:34px;border:1px solid #e7e7eb;margin:20px 0;" 
                        class="bradius" 
                        @on-click="getCompanyList(1)" 
                        @keyup.enter.native="getCompanyList(1)" 
                        autocomplete="off"></Input>
                    </div>
                </div>
                <div class="bottom" style="border:1px solid #e6e6e6;box-sizing: border-box;">
                    <Table :columns="columns7" :data="data6" :loading="loading"></Table>
                    <Page :page-size="pageSize" :total="total" show-total :current="searchModel.page" @on-change="updatePage" style="position:absolute;bottom:20px;left:38%;"></Page>
                </div>
            </div>
        </div>
        <div class="alertBox" v-if="account_log_show">
                <div class="tanchuan" style="width:600px;height:600px;overflow:hidden;">
                    <div class="tantop">
                        <div class="fl_left tantitle">设置消费记录</div>
                        <div class="fl_right tandel" @click="hiddenAccountAlert"></div>
                        <div class="clear"></div>
                    </div>
                    <div>
                        <div class="tancenter" style="overflow-y:auto;height: 100%;padding-bottom: 30px;">
                            <div class="list listpad">
                                <div class="fl_left name">消费项目</div>
                                <div class="fl_left inputBox" style="position: relative;width:390px;">
                                    <Input v-model="target_name" class="borDiv" placeholder="请输入消费项目"></Input>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="list listpad">
                                <div class="fl_left name">消费金额</div>
                                <div class="fl_left inputBox" style="width:380px;">
                                    <Input v-model="fee" placeholder="请输入消费金额" class="borDiv" type="number"  search enter-button="¥" ></Input>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="tanBtn" style="margin:0 auto" @click="setAccountLog">确定</div>
                            <div class="list listpad">
                                <el-table :data="accountLogs" style="width: 100%; height:320px">
                                    <el-table-column align="center" type="index" label="序号"></el-table-column>
                                    <el-table-column align="center" prop="target_name" label="消费项目"></el-table-column>
                                    <el-table-column align="center" prop="fee" label="消费金额"></el-table-column>
                                    <el-table-column align="center" width="180" prop="created_at" label="添加时间"></el-table-column>
                                    <el-table-column align="center" label="操作">
                                        <template slot-scope="scope">
                                            <el-button
                                            size="mini"
                                            type="danger"
                                            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <Page :page-size="pageSizeAlert" :total="totalAlert" show-total :current="alertPage" @on-change="updatePageAlert" style="margin:10px auto; text-align: center"></Page>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="alertBox" v-if="account_status">
                <div class="tanchuan">
                    <div class="tantop">
                        <div class="fl_left tantitle">设置保证金及时间</div>
                        <div class="fl_right tandel" @click="account_status=false"></div>
                        <div class="clear"></div>
                    </div>
                    <div class="tancenter">
                        <div class="list listpad">
                            <div class="fl_left name">保证金</div>
                            <div class="fl_left inputBox">
                                <Input v-model="wallet_income" class="bordiv" type="number" size="large" autocomplete="off" style="width:440px;" placeholder="请输入保证金" />
                                <input type="text"  autocomplete="off" name="" style="display:none">
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">日期</div>
                            <div class="fl_left inputBox" style="height: 36px;">
                                <DatePicker 
                                type="date" 
                                format="yyyy-MM-dd" 
                                placeholder="请选择日期"
                                class="bordiv" 
                                style="width:440px;"
                                :value="payment_date"
                                @on-change="dateChange1"
                                :options="options3"
                                >
                                </DatePicker>
                            </div>
                            <div class="clear"></div>
                        </div>                        
                    </div>
                    <div class="tanBtn" style="margin:0 Auto" @click="setAccountStatus()">确定</div>
                </div>
            </div>
  </div>
</template>

<script>
    export default {
        name: 'manage',
        data () {
            return {
                //搜索model
                searchModel:{
                    province_id:"",
                    keyword:"",
                    page:1,
                    type:1,
                    country_id:"754a7162vx84bd6v92c1",
                },
                //添加model
                addCompanyModel:{
                    company_id:"",
                    name:"",
                    province_id:'',
                    city_id:[],
                    address:'',
                    linkman:'',
                    linkphone:'',
                    email:'',
                    logo:'',
                    country_id:'754a7162vx84bd6v92c1',
                    type_id:'',
                    number:'',
                    star_id:'',
                },
                type_str:'承办单位',
                setBfb:false,
                target_name:'',
                fee:'',
                wallet_income:'',
                payment_date:'',
                account_status:false,
                account:'',
                smscode:'',
                countsd:'',
                codeShowd:true,
                dialogTableVisible:false,
                gridDataId:'',
                gridData:[],
                dateList:['',''],
                setShow:false,
                account_log_show:false,
                accountLogs:[],
                imgd1:'',
                cropShow:false,
                starShow:true,
                numberShow:true,
                option: {
                    img: '',//剪切图片地址
                    size: 1,//输出图片压缩比默认为1
                    full: false,//输出截图是否缩放
                    outputType: 'jpg',//输出图片格式
                    canMove: true,//是否可以拖动图片
                    fixedBox: true,//是否固定截图大小
                    original: false,//上传图片按原始比例
                    canMoveBox: false,//是否可以拖动截图框
                    autoCrop: true,//是否自成截图框
                    // 只有自动截图开启 宽度高度才生效
                    autoCropWidth: 300,//截图框宽
                    autoCropHeight: 300,//截图框高
                    centerBox: false,//截图框能否超过图片
                    high: true//是否根据dpr输出高清图片
                },
                maxnum:'',
                provinceArr:[],
                cities:[],
                num:0,
                curRow:'',//当前行
                items:[
                    {
                        name:'独家承办单位',
                        type:1
                    },
                    {
                        name:'承办单位',
                        type:2
                    },
                ],
                total:null,
                pageSize:10,
                alertPage:1,
                totalAlert:null,
                pageSizeAlert:5,
                loading:false,
                stop_reason:'',
                columns7: [
                    {
                        title: '序号',
                        type: 'index',
                        align: 'center',
                        width:80
                    },
                    {
                        title: '承办单位logo',
                        align: 'center',
                        key: 'logo',
                        render: (h, params) => {
                            return h('div',[
                                h('img',{
                                    style:{
                                        width:'70px',
                                    },
                                    domProps: {
                                        src:params.row.logo==''?'static/imgs/logo@3x.png':params.row.logo
                                    }
                                })
                            ])
                        }
                    },
                    {
                        title: '承办单位名称',
                        align: 'center',
                        key: 'name'
                    },
                    {
                        title: '国家城市',
                        align: 'center',
                        key: 'country',
                        render:(h,params)=>{
                            return h('div',
                            (params.row.country==''?'--':params.row.country+"/") +
                            (params.row.country=='中国'?(params.row.province+(params.row.city==''?'':'/')+params.row.city):params.row.address)
                            );
                        }
                    },
                    {
                        title: '联系方式',
                        align: 'center',
                        key: 'linkman',
                        render: (h, params) => {
                            return h('div', [
                                h('div', {}, params.row.linkman),
                                h('div', {}, params.row.linkphone),
                            ]);
                        }
                    },
                    {
                        title: '保证金总额',
                        align: 'center',
                        key: 'wallet_income',
                        render:(h,params)=>{
                            return h('div',params.row.wallet_income==''?'无':params.row.wallet_income);
                        }
                    },
                    {
                        title: '保证金余额',
                        align: 'center',
                        key: 'balance_fee',
                        render:(h,params)=>{
                            return h('div',params.row.balance_fee==''?'无':params.row.balance_fee);
                        }
                    },                    
                    {
                        title: '消费记录',
                        align: 'center',
                        key: 'accounts_log',
                        render: (h, params) => {
                            let _str    = '消费记录';
                            return h('div', [
                                h('button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    style: {
                                        backgroundColor:'rgba(0,0,0,0)',
                                        border:'none',
                                    },
                                    on: {
                                        click: () => {
                                            let _this=this;
                                            _this.target_name = '';
                                            _this.fee = '';
                                            _this.company_id = params.row.id;
                                            _this.getCompanyAccountsLog();
                                            _this.account_log_show = true;
                                        }
                                    }
                                },_str),
                            ]);
                        }
                    },
                    {
                        title: '需缴纳保证金时间',
                        align: 'center',
                        key: 'payment_date',
                        render:(h,params)=>{
                            return h('div',params.row.payment_date==''?'无':params.row.payment_date);
                        }
                    }, 
                    {
                        title: '当年保证金是否缴纳',
                        align: 'center',
                        key: 'status',
                        render: (h, params) => {
                                return h('div', [
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                _this.wallet_income = params.row.wallet_income;
                                                _this.payment_date = params.row.payment_date;
                                                _this.company_id = params.row.id;
                                                _this.account_status = true;
                                            }
                                        }
                                    }, params.row.status==0?'否':'是')
                                ]);
                        }
                    }
                ],
                data6: [],
                alertShow:false,
                valm:0,
                company_id:'',
                company_name:'',
                clnum:1,
                countryList:[],
                is_pay:'',
                is_stop:'',
                keyphone:'',    //关键手机号
                rateHistory:[], //分成比例修改历史
                incomeList:[], //收益列表页码
                incomePageNum:1, //收益列表页码
                incomePageSize:10, //收益列表每页数量
                incomePageTotal:null, //收益列表总数

                companyTypeList:[], //承办单位类型列表
                starList:[], //星级列表
            }
        },
        methods:{
            tab(index,item){
                let _this=this;
                _this.num=index;
                _this.searchModel.type=item.type;
                _this.searchModel.keyword='';

                _this.getCompanyList(1);
            },
            dateChange1(value){
                this.payment_date=value;
            },
            //添加保证金
            setAccountStatus(){
                let _this=this;
                if(_this.wallet_income===''){
                    _this.$Message.error('请输入保证金');
                    return;
                }
                if(_this.payment_date===''){
                    _this.$Message.error('请选择日期');
                    return;
                }
                _this.$axios.post('setaccountstatus',{
                    company_id:_this.company_id,
                    wallet_income:_this.wallet_income,
                    payment_date:_this.payment_date
                }).then(res=>{
                    if(res.data.code==200){
                        _this.account_status=false;
                        _this.$Message.success('添加保证金成功');
                        _this.getCompanyList(1);
                    }
                    else{
                        _this.loading=false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            handleDelete(index, row){
                // alert(row.target_name);
                let _this=this;
				this.$confirm('确定删除'+row.target_name+'吗？', '提示', {
		          	onfirmButtonText: '确定',
		          	cancelButtonText: '取消',
		         	type: 'warning'
		     	}).then(() => {
				    	_this.$axios.post('deletetarget',{
                         target_id:row.id
                        }).then(res=>{
                            if(res.data.code==200){
                                _this.$Message.success('删除记录成功！');
                                _this.getCompanyAccountsLog(1);
                                _this.getCompanyList(1);
                            }
                            else{
                                _this.loading=false;
                                this.$Message.error(res.data.message);
                            }
                        }).catch(function (error) {
                        console.log(error);
                        });
		        }).catch(() => {          
		        });
            },
            //设置消费记录
            setAccountLog(){
                let _this=this;
                _this.$axios.post('settarget',{
                    company_id:_this.company_id,
                    target_name:_this.target_name,
                    fee:_this.fee
                }).then(res=>{
                    if(res.data.code==200){
                        // _this.alertPage = 1;
                        _this.$Message.success('添加消费成功！');
                        _this.getCompanyAccountsLog(1);
                        _this.getCompanyList(1);
                    }
                    else{
                        _this.loading=false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            hiddenAccountAlert(){
                let _this=this;
                _this.account_log_show=false;  
                 _this.alertPage = 1;
            },
            updatePageAlert(num) {
                this.alertPage = num;
                this.getCompanyAccountsLog(0);
            },
            //获取承办单位消费记录
            getCompanyAccountsLog(index){
                let _this=this;
                _this.$axios.post('getcompanyaccountslog',{
                    page:_this.alertPage,
                    company_id:_this.company_id
                }).then(res=>{
                    if(res.data.code==200){
                        _this.totalAlert=res.data.data.total;
                        _this.accountLogs=res.data.data.list;
                    }
                    else{
                        _this.loading=false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            //获取承办单位记账列表
            getCompanyList(index){
                let _this=this;
                if(index==1){
                    _this.searchModel.page=1;
                }
                _this.$axios.post('getcompanyaccountslist',_this.searchModel).then(res=>{
                    if(res.data.code==200){
                        _this.total=res.data.data.total;
                        _this.data6=res.data.data.list;
                        _this.keyphone = res.data.data.phone;

                        _this.loading=false;
                    }
                    else{
                        _this.loading=false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            updatePage(num) {
                this.searchModel.page = num;
                this.getCompanyList(0);
            },
            //获取省份列表
            getProvinceList(){
                let _this=this; 
                _this.$axios.post('getprovincelist',{}).then(res=>{
                    if(res.data.code==200){
                        _this.provinceArr=res.data.data;
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            //获取城市
            getCityList(){
                let _this=this; 
                _this.$axios.post('getcitylist',{
                    province_id:_this.addCompanyModel.province_id
                }).then(res=>{
                    if(res.data.code==200){
                        _this.cities=res.data.data;
                        _this.alertShow = true;
                    }
                    else{
                        _this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            //获取国家
            getcountry(){
                let _this=this; 
                _this.$axios.post('getcountrylist',{}).then(res=>{
                    if(res.data.code==200){
                        _this.countryList=res.data.data;
                    }
                    else{
                        _this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //获取承办单位类型
            getCompanyType(){
                let _this=this; 
                _this.$axios.post('getcompanytype',{}).then(res=>{
                    if(res.data.code==200){
                        _this.companyTypeList = res.data.data;
                    }
                    else{
                        _this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //获取星级
            getStarList(){
                let _this=this; 
                _this.$axios.post('getstarlist',{}).then(res=>{
                    if(res.data.code==200){
                        _this.starList = res.data.data;
                    }
                    else{
                        _this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            }
        },
        created(){
            let _this=this; 
            let luder = JSON.parse(localStorage.getItem("luder"));
            _this.getcountry();
            _this.getCompanyType();
            _this.getStarList();
            _this.getProvinceList();
            if(luder!=null){
                _this.searchModel = luder;
            }
            _this.getCompanyList();
        },
        watch: {
             "addCompanyModel.type_id": function (val, oldVal) {
                    for(var i in this.companyTypeList){
                        if (this.companyTypeList[i].id == this.addCompanyModel.type_id){
                            this.type_str = this.companyTypeList[i].name;
                            console.log(this.type_str);
                            if (this.type_str == '独家承办单位' || this.type_str == '承办单位'){
                                this.starShow = true;
                                this.numberShow = false;
                            }else{
                                this.starShow = false;
                                this.numberShow = true;
                            }
                        }
                    }
             }
             
        }
    }
</script>

<style scoped>
/**/
    .codeBtn{
        cursor:pointer;
        position: absolute;
        top: 2px;
        right: 0;
        width: 90px;
        height: 30px;
        background-color: #ffffff;
        border: solid 1px #dc4e5a;
        color: #dc4e5a;
        text-align: center;
        line-height: 30px;
        font-size: 14px;
    }
    .selVox{
        overflow: hidden;
        height: 80px;
        line-height: 80px;
    }
    .add {
        width: 150px;
        height: 150px;
        float: left;
        cursor: pointer;
        background: url(../../../static/imgs/logoadd.png) no-repeat;  /*// 这里使用的是我本地图片*/
        background-size: 100% 100%;
    }
/**/
    /* .urlLogo{
        width: 150px;
        height: 210px;
        background: #f5f5fa url('../../../static/imgs/baadd.png') center center/30px no-repeat;
        border: solid 1px #e5e5e5;
        position: relative;
        overflow: hidden;
    } */
    .urlLogo1{
        width: 150px;
        height: 150px;
        border: solid 1px #e5e5e5;
    }
    .urlLogo input{
        position: absolute;
        top:0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0;
    }
    .urlLogo img{
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        /*z-index: 999;*/
    }
    .borDiv{
        border: 1px solid #e7e7eb;
        border-radius: 4px;
        overflow: hidden;
        width: 290px;
    }
    .name{
        line-height: 36px;
        text-align: right;
        color: #333;
        margin-right: 16px;
        width: 136px;
    }
    .wzbarBox{
      /* width: 134px; */
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      align-items:center;
      height: 61px;
    }
    .wzbar{
      color: #999;
      display: flex;
      display: -webkit-flex;
      align-items:center;
      flex-direction:column;
      line-height: 58px;
      cursor: pointer;
      margin-right: 20px;
    }
    .wzbar>span{
      display: block;
      width: 55px;
      height: 3px;
      background-color: #f6f6f6;
    }
    .wzbars{
      color: #c30d23;
    }
    .wzbars>span{
      background-color: #c30d23;
    }
    .title{
        line-height: 68px;
        color: #303030;
        font-size: 18px;
    }
    .content,#manage{
        width: 100%;
    }
    .botBox{
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        padding-bottom: 20px;
        min-height: 785px;
        position: relative;
        border:1px solid #e6e6e6;
    }
    .center,.bottomBox{
        padding: 0 20px;
        box-sizing: border-box;
    }
    .top,.center,.bottom,.bottomBox{
        width: 100%;
    }
    .top{
        height: 62px;
        line-height: 62px;
        border-bottom: 1px solid #e6e6e6;
        /*padding: 0 20px;*/
        box-sizing: border-box;
        position: relative;
        margin-bottom: 25px;
    }
    .showBox{
        position: absolute;
        right: 20px;
        top:65px;
        z-index: 99;
    }
    .shdawBot{
        padding: 0 30px 15px;
        box-sizing: border-box;
    }
    .addClass{
        width: 132px;
        height: 36px;
        border-radius: 2px;
        background-color: #c30d23;
        color: #fff;
        line-height: 36px;
        text-align: center;
        margin-top: 22px;
        cursor: pointer;
    }
    .borDiv{
        border: 1px solid #e7e7eb;
        border-radius: 4px;
        overflow: hidden;
        width: 290px;
    }
    .name{
        line-height: 36px;
        text-align: right;
        color: #333;
        margin-right: 16px;
        width: 116px;
    }
</style>



// WEBPACK FOOTER //
// src/components/finance/accounts.vue